export default __webpack_public_path__ + "static/media/background.83b0e1a2.png";